/* GENERATED by scripts/gen-data.mjs — further reading per block (from s1.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

export const READING: Record<string, string[]> = {
  "what-ai-is.b1": [
    "hallu",
    "calib"
  ],
  "what-ai-is.b2": [
    "attn"
  ],
  "what-ai-is.b3": [
    "calib"
  ],
  "what-ai-is.b3o": [
    "ner",
    "layoutlm",
    "sbert",
    "slmsurvey"
  ],
  "what-ai-is.b4": [
    "testing",
    "calib"
  ],
  "model-families.b1": [
    "zshot",
    "mteb",
    "lora",
    "scalelaw",
    "mirage",
    "slmsurvey",
    "slmmeasure",
    "emerge",
    "chinchilla"
  ],
  "model-families.b2": [
    "sbert"
  ],
  "model-families.b3": [
    "sbert",
    "mteb"
  ],
  "model-families.b3o": [
    "mteb",
    "nli",
    "ner",
    "lora",
    "distill",
    "dstep",
    "sft"
  ],
  "model-families.b4": [
    "testing",
    "mirage",
    "distract"
  ],
  "grounding.b1": [
    "hallu",
    "lostmid",
    "selfrag",
    "beir"
  ],
  "grounding.b2": [
    "ragsurvey"
  ],
  "grounding.b3": [
    "rag",
    "lostmid"
  ],
  "grounding.b3o": [
    "ragsurvey",
    "hnsw",
    "selfrag",
    "lostmid",
    "mteb",
    "chunk",
    "rerank",
    "beir"
  ],
  "grounding.b4": [
    "testing",
    "beir",
    "distract"
  ],
  "memory.b1": [
    "memgpt",
    "memllm",
    "genagents"
  ],
  "memory.b4": [
    "cascades",
    "dcai"
  ],
  "event-bus.b1": [
    "littles",
    "kafkaflink",
    "evedit"
  ],
  "event-bus.b2": [
    "kafkapats"
  ],
  "event-bus.b3": [
    "littles",
    "kafkaflink"
  ],
  "event-bus.b3o": [
    "kafkapats",
    "littles",
    "micro",
    "evedit",
    "eda"
  ],
  "event-bus.b4": [
    "testing",
    "evedit"
  ],
  "service-split.b1": [
    "micro",
    "trace"
  ],
  "service-split.b2": [
    "micro",
    "trace"
  ],
  "service-split.b3": [
    "micro",
    "littles"
  ],
  "service-split.b3o": [
    "micro",
    "trace",
    "eda"
  ],
  "service-split.b4": [
    "testing",
    "micro"
  ],
  "frontend-composition.b1": [
    "mfe"
  ],
  "frontend-composition.b2": [
    "mfe"
  ],
  "frontend-composition.b3": [
    "mfe",
    "mfemig"
  ],
  "frontend-composition.b3o": [
    "mfemig",
    "mfe"
  ],
  "frontend-composition.b4": [
    "testing",
    "mfemig"
  ],
  "tooling.b1": [
    "react",
    "cot",
    "toolformer",
    "cotsurvey",
    "sft"
  ],
  "tooling.b2": [
    "react"
  ],
  "tooling.b3": [
    "swebench"
  ],
  "tooling.b3o": [
    "toolformer",
    "cot",
    "swebench",
    "agentbench",
    "nl2sql"
  ],
  "tooling.b4": [
    "testing",
    "agentbench",
    "distract"
  ],
  "guardrails.b1": [
    "guard",
    "conformal",
    "guided",
    "fair"
  ],
  "guardrails.b2": [
    "guard"
  ],
  "guardrails.b3": [
    "conformal"
  ],
  "guardrails.b3o": [
    "conformal",
    "guided",
    "hitl",
    "jailbreak",
    "mcards",
    "fair",
    "xai",
    "spotlight",
    "injreview"
  ],
  "guardrails.b4": [
    "testing",
    "fair",
    "distract"
  ],
  "evaluate.b1": [
    "checklist",
    "mltest",
    "ragas"
  ],
  "evaluate.b2": [
    "helm"
  ],
  "evaluate.b3": [
    "checklist",
    "helm",
    "mltest"
  ],
  "evaluate.b3o": [
    "helm",
    "llmjudge",
    "mltest",
    "ragas",
    "agentbench",
    "abtest",
    "distract"
  ],
  "evaluate.b4": [
    "testing",
    "distract"
  ],
  "production.b1": [
    "mcards",
    "datasheet",
    "dcai",
    "cascades"
  ],
  "production.b2": [
    "anomdet"
  ],
  "production.b3": [
    "mltest"
  ],
  "production.b3o": [
    "mcards",
    "datasheet",
    "dpsgd",
    "anomdet",
    "dcai",
    "abtest",
    "iaa"
  ],
  "production.b4": [
    "testing",
    "cascades",
    "iaa"
  ],
  "x-softmax.b1": [
    "calib",
    "attn"
  ],
  "x-softmax.b2": [
    "calib"
  ],
  "x-softmax.b3": [
    "calib",
    "conformal"
  ],
  "x-delivery.b1": [
    "kafkaflink",
    "kafkapats"
  ],
  "x-delivery.b2": [
    "kafkaflink"
  ],
  "x-delivery.b3": [
    "evedit",
    "littles"
  ],
  "x-contracts.b1": [
    "micro",
    "eda"
  ],
  "x-contracts.b2": [
    "micro",
    "eda"
  ],
  "x-contracts.b3": [
    "micro",
    "eda",
    "iaa"
  ],
  "x-threats.b1": [
    "inj",
    "jailbreak",
    "guided",
    "guard"
  ],
  "x-threats.b2": [
    "jailbreak"
  ],
  "x-threats.b3": [
    "spotlight",
    "injreview",
    "fair"
  ],
  "x-drift.b1": [
    "drift",
    "anomdet",
    "mltest"
  ],
  "x-drift.b2": [
    "drift"
  ],
  "x-drift.b3": [
    "drift",
    "abtest",
    "dcai"
  ],
  "x-cost.b1": [
    "infer",
    "gptq",
    "frugal",
    "routellm",
    "pcache",
    "specdec",
    "lora",
    "distill",
    "dstep"
  ],
  "x-cost.b2": [
    "specdec"
  ],
  "x-cost.b3": [
    "distill",
    "frugal",
    "routellm"
  ],
  "x-curriculum.b1": [
    "curri",
    "kt",
    "spaced",
    "testing",
    "retrieval",
    "interleave",
    "clt",
    "feedback"
  ],
  "x-curriculum.b2": [
    "spaced",
    "interleave",
    "hlr"
  ],
  "x-curriculum.b3": [
    "feedback",
    "retrieval",
    "testing"
  ],
  "bonus-pipeline.b1": [
    "slmsurvey",
    "textbooks",
    "dstep"
  ]
};
